import { Card } from '@startuptools/ui/Card';
import { Stack } from '@startuptools/ui/Stack';
import { MeetingMinutesDocument } from '../../common/components/documents/MeetingMinutes';
import { SiDocumentsShowDocument, useSiDocumentsShowSuspenseQuery } from './DocumentsShow.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { ShareIssueRegistrationForm } from '../../common/components/documents/ShareIssueRegistrationForm';
import { SipShareSubscriptionNoteList } from '../../common/components/documents/SipShareSubscriptionNoteList';
import { RegistrationToDoList } from '../../common/components/RegistrationToDoList';

export const SiDocumentsShow = ({ shareIssueId }: { shareIssueId: string }) => {
  const companyId = useCompanyId();
  const {
    data: {
      shareIssue: { meetingConcern, shareIssueRegistrations },
    },
  } = useSiDocumentsShowSuspenseQuery({ variables: { companyId, shareIssueId }, fetchPolicy: 'cache-and-network' });

  const sir = shareIssueRegistrations.at(0);

  return (
    <Stack gap={3}>
      <Card>
        <Stack gap={3}>
          {meetingConcern && <MeetingMinutesDocument meeting={meetingConcern.meeting} />}

          {sir && <ShareIssueRegistrationForm shareIssueId={shareIssueId} shareIssueRegistration={sir} />}

          <SipShareSubscriptionNoteList shareIssueId={shareIssueId} />
        </Stack>
      </Card>
      {sir && (
        <RegistrationToDoList
          shareRegistrationId={sir.id}
          todos={sir.todos}
          completions={sir.todoCompletions}
          refetchQueries={[SiDocumentsShowDocument]}
        />
      )}
    </Stack>
  );
};
